
export const GENERAL_EN = {
    "general": {
        "contact": "Contact",
        "confirm-text": "Are you sure that you want to proceed?",
        "new-reental": "New Mindmap",
        "premium-feature": "Premium Feature. Unlock it now!",
        "special-themes": "Special themes",
        "solid-themes": "Solid themes",
    },
    "dashboard": {
        "is-public": "Public",
    },
    "contact": {
        "subject": "Subject",
        "message": "Message",
        "send": "Send"
    },
    "menu": {
        "dashboard": "Dashboard",
        "profile": "Profile",
        "new-reental": "New Mindmap",
        "contact": "Contact",
        "subscription": "Subscription",
        "store": "Store",
        "affiliates": "Affiliates",
        "logout": "Logout",
        "available-credits": "Available credits",
    },
    "login": {
        "not-have-account": "Don't have an account?",
        "register": "Create today!",
        "email": "Email",
        "password": "Password",
        "remember": "Remember me",
        "acceptTerms": "I accept the terms and conditions",
        "login": "Login",
        "success": "Login success! Redirecting...",
        "errors": {
            "INVALID_PASSWORD": "The password is invalid",
            "USER_NOT_FOUND": "The email is not registered",
            "PENDING_CONFIRMATION": "The account is not confirmed. Please check your inbox or spam folder",
            "DEFAULT": "Error logging in. Please try again later"
        }
    },
    "register": {
        "have-account": "Already have an account?",
        "login": "Login",
        "name": "Name",
        "country": "Country",
        "email": "Email",
        "password": "Password",
        "repeat-password": "Repeat password",
        "register-button": "Register",
        "confirmation-code-success": "Account confirmed successfully! Redirecting...",
        "confirmation-code-error": "Error confirming account. Please try again later",
        "confirmation-code-invalid": "The code entered is not correct. If the problem persists, contact the administrator",
        "email-already-in-use": "The email is already in use",
        "register-success": "Account created successfully. A confirmation email has been sent to activate the account. Check your inbox or spam folder",
        "passwords-not-match": "Passwords do not match",
        "register-generic-error": "Error creating account. Please try again later"
    },
    "profile": {
        "edit-profile": "Edit Profile",
        "form-field-name": "Name",
        "form-field-language": "Language",
        "edit-profile-success": "Profile updated successfully. Reloading...",
        "edit-profile-error": "Error updating profile",
        "edit-profile-button-update": "Update profile",
        "choose-avatar-button": "Choose Image"
    },
    "public-menu": {
        "dashboard": "Dashboard",
        "register": "Register",
        "login": "Login",
    }
}
